import React, { Component } from 'react';
import CreateStudy  from '../../components/study';
import { saveStudy, setStudyMsg} from '../../actions/study';
import {connect} from 'react-redux';

class Study extends Component {
  constructor(props){
    super(props) 
    this.state = {
    }
    this.saveStudy = this.saveStudy.bind(this);
    this.studyList = this.studyList.bind(this);
  }

    componentWillMount() {
      this.props.dispatch(setStudyMsg());
    }

    saveStudy(studyData){
      this.props.dispatch(saveStudy(studyData));
    }

    studyList(){
      this.props.history.push('/studyList');
    }


  render() {
    let createStudy = '';
      if(!this.props.authenticated){
       
          let adminToken=sessionStorage.getItem("adminToken");
            if(adminToken){
              createStudy = <CreateStudy
                        saveStudy = {this.saveStudy}
                        studyMessage = {this.props.studyMessage}
                        studyList = {this.studyList}
                       />
          }else {
            alert("Please login.");
            this.props.history.push("login");
          }
      }
      if(this.props.authenticated){
        
          createStudy = <CreateStudy
                        saveStudy = {this.saveStudy}
                        studyMessage = {this.props.studyMessage}
                        studyList = {this.studyList}
                       />
      }
        


   return (<div>
          {createStudy}
          </div>
   );
  }
}

const  mapStateToProps =(state) =>{
  return {
      authenticated : state.login.authenticated,
      studyMessage : state.study.studyMessage,
  }
}

export default connect(mapStateToProps)(Study);



// WEBPACK FOOTER //
// ./src/pages/study/index.js